import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '满格啦'
          }
        }, {
          path: '/goods',
          name: 'goods',
          component: resolve => require(['@/view/goods'], resolve),
          meta: {
            title: '满格啦|产品展示'
          }, 
        },
         {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '满格啦|新闻动态'
          }
        }, 
         {
          path: '/newsDetails',
          name: 'newsDetails',
          component: resolve => require(['@/view/newsDetails'], resolve),
          meta: {
            title: '满格啦|新闻动态|新闻详情',
            noCache: true 
          }
        }, 
        {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '满格啦|关于我们'
          }
        },
        {
          path: '/ccie',
          name: 'ccie',
          component: resolve => require(['@/view/ccie'], resolve),
          meta: {
            title: '满格啦|证书查询'
          },
          children: [
            {
              path: '/ccie',
              redirect: '/ccie/operation'
            },
            // {
            //   path: '/ccie/people',
            //   name: 'ccie',
            //   component: resolve => require(['@/view/ccie_people'], resolve),
            //   meta: {
            //     title: '满格啦|证书查询丨工作人员查询'
            //   }
            // },
            {
              path: '/ccie/area',
              name: 'ccie',
              component: resolve => require(['@/view/ccie_area'], resolve),
              meta: {
                title: '满格啦|证书查询丨区级服务商查询'
              }
            },
            {
              path: '/ccie/city',
              name: 'ccie',
              component: resolve => require(['@/view/ccie_city'], resolve),
              meta: {
                title: '满格啦|证书查询丨市级服务商查询'
              }
            },
            {
              path: '/ccie/operation',
              name: 'ccie',
              component: resolve => require(['@/view/ccie_operation'], resolve),
              meta: {
                title: '满格啦|证书查询丨合作伙伴查询'
              }
            }
          ]
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js